(() => {
  const init = (root) => {
    root.querySelectorAll('.ecom-swiper-container').forEach((slider) => {
      if (slider.dataset.mpNativeCarousel === 'true') return;
      const wrapper = slider.querySelector(':scope > .ecom-swiper-wrapper');
      const slides = wrapper ? Array.from(wrapper.children).filter((el) => el.classList.contains('ecom-swiper-slide')) : [];
      if (!wrapper) {
        slider.style.opacity = '1';
        slider.style.visibility = 'visible';
        return;
      }

      const controlsScope = slider.closest('.ecom-slider--container, .ecom-collection__product-container, .ecom-testimonials--container') || slider;
      const previous = controlsScope.querySelector('.ecom-swiper-button-prev');
      const next = controlsScope.querySelector('.ecom-swiper-button-next');
      const pagination = controlsScope.querySelector('.ecom-swiper-pagination');
      const disableControl = (control, disabled) => {
        if (!control) return;
        control.disabled = disabled;
        control.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      };

      slider.classList.add('ecom-swiper-initialized', 'ecom-swiper-horizontal', 'ecom-swiper-container-initialized');
      controlsScope.classList.add('ecom-swiper-initialized-wrapper');
      wrapper.classList.add('ecom-swiper-initialized-wrapper');
      slider.dataset.mpNativeCarousel = 'true';
      slider.dataset.mpNativeCarouselReady = 'true';
      slider.style.opacity = '1';
      slider.style.visibility = 'visible';
      wrapper.style.opacity = '1';
      wrapper.style.visibility = 'visible';

      if (slides.length < 2) {
        wrapper.style.transform = 'translate3d(0,0,0)';
        slides.forEach((slide) => {
          slide.style.opacity = '1';
          slide.style.visibility = 'visible';
          slide.style.transform = 'translate3d(0,0,0)';
          slide.setAttribute('aria-hidden', 'false');
        });
        disableControl(previous, true);
        disableControl(next, true);
        pagination?.setAttribute('aria-disabled', 'true');
        return;
      }

      let options = {};
      try {
        options = JSON.parse(slider.getAttribute('data-option-swiper') || '{}');
      } catch (_) {
        options = {};
      }

      let index = Math.max(0, slides.findIndex((slide) => slide.classList.contains('ecom-box-active')));
      let pointerStart = null;
      let paused = false;
      const dots = [];

      const visibleCount = () => {
        let configured = Number(options.slidesPerView) || 1;
        const breakpoints = options.breakpoints && typeof options.breakpoints === 'object' ? options.breakpoints : {};
        Object.keys(breakpoints)
          .map(Number)
          .filter((point) => Number.isFinite(point) && window.innerWidth >= point)
          .sort((a, b) => a - b)
          .forEach((point) => {
            configured = Number(breakpoints[point]?.slidesPerView) || configured;
          });
        return Math.max(1, Math.min(slides.length, configured));
      };

      const maxIndex = () => Math.max(0, slides.length - visibleCount());
      const show = (nextIndex) => {
        const visible = visibleCount();
        const maximum = maxIndex();
        index = options.loop ? (nextIndex + maximum + 1) % (maximum + 1) : Math.max(0, Math.min(maximum, nextIndex));
        const width = 100 / visible;
        slides.forEach((slide) => { slide.style.flex = `0 0 ${width}%`; });
        wrapper.style.transform = `translate3d(${-index * width}%,0,0)`;
        slides.forEach((slide, i) => {
          const visibleSlide = i >= index && i < index + visible;
          slide.classList.toggle('ecom-box-active', i === index);
          slide.setAttribute('aria-hidden', visibleSlide ? 'false' : 'true');
        });
        dots.forEach((dot, i) => {
          dot.hidden = i > maximum;
          dot.setAttribute('aria-current', i === index ? 'true' : 'false');
        });
        disableControl(previous, index === 0);
        disableControl(next, index === maximum);
      };

      if (pagination) {
        pagination.replaceChildren();
        slides.forEach((_, dotIndex) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'mp-carousel-dot';
          dot.setAttribute('aria-label', 'Folie ' + (dotIndex + 1));
          dot.addEventListener('click', () => show(dotIndex));
          pagination.appendChild(dot);
          dots.push(dot);
        });
      }

      previous?.addEventListener('click', () => show(index - 1));
      next?.addEventListener('click', () => show(index + 1));
      slider.addEventListener('pointerdown', (event) => { pointerStart = event.clientX; });
      slider.addEventListener('pointerup', (event) => {
        if (pointerStart !== null && Math.abs(event.clientX - pointerStart) > 40) show(index + (event.clientX < pointerStart ? 1 : -1));
        pointerStart = null;
      });
      slider.addEventListener('pointercancel', () => { pointerStart = null; });
      slider.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') { event.preventDefault(); show(index - 1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); show(index + 1); }
      });
      window.addEventListener('resize', () => show(index), { passive: true });

      slider.setAttribute('role', 'region');
      slider.setAttribute('tabindex', '0');
      slider.setAttribute('aria-label', 'Bildergalerie ' + (Array.from(document.querySelectorAll('.ecom-swiper-container')).indexOf(slider) + 1));
      show(index);

      const autoplay = options.autoplay && typeof options.autoplay === 'object' ? options.autoplay : {};
      if (autoplay.enabled) {
        const delay = Math.max(1000, Number(autoplay.delay) || 6000);
        if (autoplay.pauseOnMouseEnter) {
          slider.addEventListener('mouseenter', () => { paused = true; });
          slider.addEventListener('mouseleave', () => { paused = false; });
        }
        const advance = () => {
          window.setTimeout(() => {
            if (!slider.isConnected) return;
            if (!paused && maxIndex() > 0) show(index >= maxIndex() ? 0 : index + 1);
            advance();
          }, delay);
        };
        advance();
      }
    });
  };

  const boot = () => document.querySelectorAll('.mp-page-native, .mp-page-native-static, [data-mp-native-page], .ecom-vbobjhetuy9').forEach(init);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot, { once: true }) : boot();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
